import React from 'react';
import { GradientDivider } from './SectionDividerStyle';

const SectionDivider = () => {
  return (
    <GradientDivider className={'section-divider'}/>
  )
};

export default SectionDivider;
